<div class="row align-items-center mb-2">
  <div class="col-7">
    <ng-select [items]="inventoryProducts"
               bindLabel="name"
               bindValue="id"
               [groupBy]="groupByFirstWord"
               [(ngModel)]="selectedProductId"
               placeholder="Chọn sản phẩm kho"
               [searchable]="true"
               [clearable]="true"
               (ngModelChange)="emitOutput()">
      <ng-template ng-label-tmp let-item="item">
        <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;"> {{item.name}}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;"> {{item.name}}
      </ng-template>
    </ng-select>
  </div>
  <div class="col-3">
    <input type="number" class="form-control" [(ngModel)]="quantity" min="1" placeholder="Số lượng" (ngModelChange)="emitOutput()" />
  </div>
</div>
 
